<template>
  <el-row class="service-content">
    <el-col>
      <el-table row-key="Id" :header-cell-style="{'background-color': 'rgb(227,227,227)'}" :row-style="{'background-color': 'whitesmoke'}"
        :cell-style="{'border-bottom': 0}" :show-summary="true" :summary-method="getTabelSummaries" :data="dataIn">
        <el-table-column prop="ServiceName" label="真留项目" min-width="160" />
        <el-table-column prop="SaleAmount" label="原价" min-width="110" :formatter="(row, column, cellValue, index) => Object.toCurrency(cellValue, row.WorkflowCurrency)" />
        <el-table-column label="总折扣" min-width="110"
          :formatter="(row, column, cellValue, index) => `-${Object.toCurrency(row.DiscountAmount + row.CashDecreasedAmount, row.WorkflowCurrency)}`" />
        <el-table-column prop="SaleAmountDiscounted" label="应支付价格" min-width="110"
          :formatter="(row, column, cellValue, index) => Object.toCurrency(cellValue, row.WorkflowCurrency)" />
        <el-table-column prop="PaymentAmount" label="已支付价格" min-width="110"
          :formatter="(row, column, cellValue, index) => Object.toCurrency(cellValue, row.WorkflowCurrency)" />
      </el-table>
    </el-col>
  </el-row>
</template>

<script>
const mixin_generalMethods = {
  methods: {
    getTabelSummaries({ columns, data }) {
      let sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总价";
          return;
        }

        if (index === 2) {
          let sumValue = data.sum(
            (row) => row.DiscountAmount + row.CashDecreasedAmount
          );
          sums[index] = `-${Object.toCurrency(sumValue, this.currency)}`;
          return;
        }

        let sumValue = data.sum((row) => row[column.property]);
        sums[index] = Object.toCurrency(sumValue, this.currency);
      });

      return sums;
    },
  },
};

export default {
  name: "workflowServiceSummaryCard",
  mixins: [mixin_generalMethods],
  data() {
    return {};
  },
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
    dataIn: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    currency() {
      if (this.dataIn.length === 0) {
        return this.GLOBAL.currencyType.CNY;
      }

      return this.dataIn[0].WorkflowCurrency;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.service-content {
  padding: 20px 0;

  h5 {
    margin-bottom: 0;
    line-height: inherit;
    font-weight: bold;
  }
}

.el-table {
  /deep/ .el-table__footer td {
    background-color: rgb(227, 227, 227);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/workflowServiceSummaryCard.vue